export default __webpack_public_path__ + "static/media/wandacoffin.3cd87c36.png";